(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["schema-collection"] && !Shopify.designMode) return;
  try {
    (() => {
    const metadataScript = document.getElementById('schema-collection');
    if (!metadataScript) return;
    const metadata = JSON.parse(metadataScript.textContent);
    const collectionPage = metadata['@graph'].find((entity) => entity['@type'] === 'CollectionPage');
    if (!collectionPage) return;
    const canonicalOrigin = new URL(collectionPage.url).origin;
    const rootPath = (metadataScript.dataset.schemaRootUrl || '/').replace(/\/$/, '');
    const listId = `${collectionPage.url}#itemlist`;
    const listSelector = '[data-schema-collection-item-list]';
    const surface = document.querySelector('[data-schema-collection-surface]') || document.querySelector('loose-diamond-product-list, engagement-ring-product-list, #ProductGridContainer');
    let apiResult = null;
    let pendingFrame = 0;

    function productUrl(value) {
      if (!value) return null;
      try {
        const url = new URL(value, canonicalOrigin);
        let path = url.pathname.replace(/\/collections\/[^/]+(?=\/products\/)/, '');
        if (rootPath && path.startsWith('/products/')) path = `${rootPath}${path}`;
        if (!/\/products\/[^/]+$/.test(path)) return null;
        return new URL(path, canonicalOrigin).href;
      } catch {
        return null;
      }
    }

    function writeList(items, total) {
      const scripts = [...document.querySelectorAll(listSelector)];
      if (!items.length) {
        scripts.forEach((script) => script.remove());
        return;
      }
      const script = scripts.shift() || document.createElement('script');
      scripts.forEach((duplicate) => duplicate.remove());
      script.type = 'application/ld+json';
      script.setAttribute('data-schema-collection-item-list', '');
      const json = JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [
          { '@id': collectionPage['@id'], mainEntity: { '@id': listId } },
          {
            '@type': 'ItemList',
            '@id': listId,
            ...(Number.isFinite(total) ? { numberOfItems: total } : {}),
            itemListElement: items,
          },
        ],
      }).replace(/</g, '\\u003c');
      if (script.textContent !== json) script.textContent = json;
      if (script.parentNode !== document.head) document.head.append(script);
    }

    function synchronize() {
      pendingFrame = 0;
      const diamondList = document.querySelector('loose-diamond-product-list');
      if (diamondList) {
        const failed = diamondList.querySelector('[data-diamond-retry]:not([hidden])');
        if (diamondList.hasAttribute('data-loading') || failed) apiResult = null;
        writeList(apiResult?.items || [], apiResult?.items.length || 0);
        return;
      }
      const grid = surface?.querySelector('[data-schema-collection-grid]');
      const engagementList = grid?.closest('engagement-ring-product-list');
      if (!grid || grid.matches('.loading, [aria-busy="true"], [data-schema-collection-error="true"]') || engagementList?.querySelector('[data-product-retry]')) {
        writeList([], 0);
        return;
      }
      const offset = Number(grid.dataset.schemaCollectionOffset) || 0;
      const visibleScope = grid.dataset.schemaCollectionScope === 'visible';
      const products = [...grid.querySelectorAll('[data-schema-product-url], article[data-product-handle]')];
      const seen = new Set();
      const items = products.flatMap((card, index) => {
        const url = productUrl(card.dataset.schemaProductUrl || card.querySelector('a[href*="/products/"]')?.getAttribute('href'));
        if (!url || seen.has(url)) return [];
        seen.add(url);
        return [{ '@type': 'ListItem', position: visibleScope ? seen.size : offset + index + 1, url }];
      });
      const total = Number(grid.dataset.schemaCollectionTotal);
      writeList(items, visibleScope ? items.length : Number.isFinite(total) ? total : items.length);
    }

    function schedule() {
      if (!pendingFrame) pendingFrame = requestAnimationFrame(synchronize);
    }

    function recordDiamondResult(list) {
      const products = list.items;
      if (!Array.isArray(products)) {
        apiResult = null;
      } else {
        const seen = new Set();
        const items = products.flatMap((product) => {
          const url = product.handle ? productUrl(`${rootPath}/products/${encodeURIComponent(product.handle)}`) : null;
          if (!url || seen.has(url)) return [];
          seen.add(url);
          return [{ '@type': 'ListItem', position: seen.size, url }];
        });
        apiResult = { items };
      }
    }

    document.addEventListener('da:products-rendered', (event) => {
      if (event.target.matches?.('loose-diamond-product-list')) recordDiamondResult(event.target);
      schedule();
    });

    if (surface) {
      const observer = new MutationObserver(schedule);
      observer.observe(surface, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-busy', 'data-loading', 'hidden', 'data-schema-collection-error', 'data-schema-product-url', 'data-schema-collection-offset', 'data-schema-collection-total', 'data-schema-collection-scope'],
      });
      if (surface.matches('loose-diamond-product-list') && surface.items?.length) {
        recordDiamondResult(surface);
      }
    }
    synchronize();
  })();
  } catch(e) { console.error(e); }
})();

})();
